import { ChevronDown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { desktopNav } from './navigationData';

export default function DesktopNavigation({ isLight, activeMenu, onOpen, onClose }) {
  const navColor = isLight ? 'text-soft-black' : 'text-arch-white';
  return (
    <nav className="hidden items-center gap-1 xl:flex" aria-label="Primary navigation" data-testid="desktop-navigation">
      {desktopNav.map((item) => item.type === 'mega' ? (
        <button
          key={item.label}
          type="button"
          className={`inline-flex min-h-[44px] items-center gap-1 border-b border-transparent px-2.5 text-[11px] font-medium tracking-[0.08em] transition-[border-color,color] duration-150 hover:border-current ${navColor}`}
          onMouseEnter={() => onOpen(item.label)}
          onFocus={() => onOpen(item.label)}
          onKeyDown={(event) => { if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') { event.preventDefault(); onOpen(item.label); } }}
          aria-haspopup="dialog"
          aria-expanded={activeMenu === item.label}
          aria-controls="capabilities-mega-menu"
          data-testid="nav-capabilities-menu-button"
        >
          {item.label}<ChevronDown size={14} className={`transition-transform duration-150 ${activeMenu === item.label ? 'rotate-180' : ''}`} aria-hidden="true" />
        </button>
      ) : (
        <Link
          key={item.label}
          to={item.href}
          onFocus={onClose}
          className={`inline-flex min-h-[44px] items-center border-b border-transparent px-2.5 text-[11px] font-medium tracking-[0.08em] transition-[border-color,color] duration-150 hover:border-current ${navColor}`}
          data-testid={`nav-${item.label.toLowerCase()}-link`}
        >{item.label}</Link>
      ))}
    </nav>
  );
}